
import React from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry } from './config/sentry'
import App from './App.tsx'
import 'hbox-call/dist/ui/styles.css';
import 'hbox-sms/dist/hbox-sms.css';
import 'hbox-fax/dist/hbox-fax.css';
import './index.css'

// Initialize Sentry
initSentry();

createRoot(document.getElementById("root")!).render(<App />); // no-op rebuild trigger
